import React from "react";
import PostItem from "./PostItem";
import style from "./../Items.module.scss";
import CircularProgress from "../../../../CircularProgress/CircularProgress";
import { LoadingMessage } from "../Summary";

const PostList = ({ loadingAlert, events, fetchs }) => {
  return (
    <div className={style.posts}>
      {loadingAlert && <LoadingMessage text={"Retrieving events"} />}

      {!loadingAlert &&
        events &&
        events.map((e) => (
          <PostItem
            key={`ev-${e.id}`}
            user={e.user}
            date={e.date}
            message={e.message}
            files={e.files}
            downloadFile={fetchs.downloadFile}
          />
        ))}
      {!loadingAlert && events && events.length == 0 && (
        <span className={style.empty} style={{ textAlign: "center" }}>
          No events
        </span>
      )}
    </div>
  );
};

export default PostList;
